import { NavLink, Link } from 'react-router-dom';
import { ShieldMark } from './ShieldMark';
import { useAuth } from '../contexts/AuthContext';

export function Header() {
  const { user } = useAuth();

  const navClass = ({ isActive }: { isActive: boolean }) =>
    `text-sm tracking-[0.08em] uppercase transition-colors duration-200 ${
      isActive ? 'text-terracotta' : 'text-forest hover:text-terracotta'
    }`;

  return (
    <header className="border-b border-forest/15 bg-cream/95 backdrop-blur sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <span className="text-forest group-hover:text-terracotta transition-colors">
            <ShieldMark size={36} />
          </span>
          <div className="text-left">
            <div
              className="text-xl font-medium text-forest leading-none font-display"
              style={{ fontVariationSettings: '"opsz" 144' }}
            >
              MowKind
            </div>
            <div className="text-[10px] tracking-[0.2em] text-forest/60 uppercase mt-1">
              Coastal Bend · Est. 2026
            </div>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-6 lg:gap-8">
          <NavLink to="/" end className={navClass}>Home</NavLink>
          <NavLink to="/about" className={navClass}>About</NavLink>
          <NavLink to="/lifecycle" className={navClass}>How It Works</NavLink>
          <NavLink to="/apply" className={navClass}>Request a Mow</NavLink>
          <NavLink to="/hire" className={navClass}>Support a Mowkin</NavLink>
          <NavLink to="/provider" className={navClass}>Become a Mowkin</NavLink>
          {user && (
            <NavLink to="/dashboard" className={navClass}>Dashboard</NavLink>
          )}
        </nav>
      </div>
    </header>
  );
}
